module.exports = __webpack_public_path__ + "static/img/sort_exp.2506ddea.jpg";